module.exports = __webpack_public_path__ + "static/img/pinpai-14.e2a985e8.png";